/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerOrderSummary } from './CustomerOrderSummary';
import {
    CustomerOrderSummaryFromJSON,
    CustomerOrderSummaryFromJSONTyped,
    CustomerOrderSummaryToJSON,
    CustomerOrderSummaryToJSONTyped,
} from './CustomerOrderSummary';

/**
 * 
 * @export
 * @interface PagedAndSyncedResultCustomerOrderSummary
 */
export interface PagedAndSyncedResultCustomerOrderSummary {
    /**
     * 
     * @type {Array<CustomerOrderSummary>}
     * @memberof PagedAndSyncedResultCustomerOrderSummary
     */
    content: Array<CustomerOrderSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultCustomerOrderSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultCustomerOrderSummary
     */
    totalPages: number;
    /**
     * 
     * @type {Date}
     * @memberof PagedAndSyncedResultCustomerOrderSummary
     */
    lastSyncedAt?: Date;
}

/**
 * Check if a given object implements the PagedAndSyncedResultCustomerOrderSummary interface.
 */
export function instanceOfPagedAndSyncedResultCustomerOrderSummary(value: object): value is PagedAndSyncedResultCustomerOrderSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedAndSyncedResultCustomerOrderSummaryFromJSON(json: any): PagedAndSyncedResultCustomerOrderSummary {
    return PagedAndSyncedResultCustomerOrderSummaryFromJSONTyped(json, false);
}

export function PagedAndSyncedResultCustomerOrderSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedAndSyncedResultCustomerOrderSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(CustomerOrderSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
    };
}

export function PagedAndSyncedResultCustomerOrderSummaryToJSON(json: any): PagedAndSyncedResultCustomerOrderSummary {
    return PagedAndSyncedResultCustomerOrderSummaryToJSONTyped(json, false);
}

export function PagedAndSyncedResultCustomerOrderSummaryToJSONTyped(value?: PagedAndSyncedResultCustomerOrderSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(CustomerOrderSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
    };
}

